module.exports = __webpack_public_path__ + "static/img/4a.70712096.png";